import { render, staticRenderFns } from "./AutocompleteCustom.vue?vue&type=template&id=34edd440&scoped=true&"
import script from "./AutocompleteCustom.vue?vue&type=script&lang=js&"
export * from "./AutocompleteCustom.vue?vue&type=script&lang=js&"
import style0 from "./AutocompleteCustom.vue?vue&type=style&index=0&id=34edd440&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34edd440",
  null
  
)

export default component.exports